import PropTypes from 'prop-types';
import React from 'react';
import $ from 'jquery';
import { isEqual } from 'lodash';

require('datatables.net-bs4');

class DataTable extends React.Component {
  static propTypes = {
    dataSource: PropTypes.string.isRequired,
    columns: PropTypes.array.isRequired,
    title: PropTypes.string,
    detailTable:PropTypes.bool,
    searchedSearchTerm: PropTypes.string,
    order: PropTypes.array,
    lengthMenu: PropTypes.array,
    reducedFilters: PropTypes.object,
    onRowClick: PropTypes.func,
    rowCallback: PropTypes.func,
    onInitComplete: PropTypes.func,
    tableClassNames: PropTypes.string,
    onTableElementSet: PropTypes.func,
    createdRow: PropTypes.func,
    zeroRecords: PropTypes.string,
    drawCallback: PropTypes.func,
    colGroup: PropTypes.element,
    onColumnReorder: PropTypes.func,
    responsive: PropTypes.bool,
    autoWidth: PropTypes.bool
  };

  static defaultProps = {
    reducedFilters: {},
    searchedSearchTerm: "",
    lengthMenu: [[10, 25, 50, 100], ["10 Rows", "25 Rows", "50 Rows", "100 Rows"]],
    onRowClick: (e, data, row) => {},
    rowCallback: (row, data, displayNum, displayIndex, dataIndex) => {},
    onInitComplete: (settings, json) => {},
    tableClassNames: "",
    onTableElementSet: (el) => {},
    createdRow: (row, data, dataIndex) => {},
    zeroRecords: "&nbsp;",
    drawCallback: (settings) => {},
    onColumnReorder: (e, settings, details) => {},
    responsive: false,
    autoWidth: true
  };

  constructor(props) {
    super(props);

    this.state = {
      dataSource: this.props.dataSource,
      columns: this.props.columns,
      title: this.props.title,
      searchedSearchTerm: this.props.searchedSearchTerm,
      order: this.props.order,
      lengthMenu: this.props.lengthMenu,
      reducedFilters: this.props.reducedFilters,
      onRowClick: this.props.onRowClick,
      rowCallback: this.props.rowCallback,
      onInitComplete: this.props.onInitComplete,
      tableClassNames: this.props.tableClassNames,
      onTableElementSet: this.props.onTableElementSet,
      createdRow: this.props.createdRow,
      zeroRecords: this.props.zeroRecords,
      drawCallback: this.props.drawCallback,
      colGroup: this.props.colGroup,
      onColumnReorder: this.props.onColumnReorder,
      responsive: this.props.responsive,
      autoWidth: this.props.autoWidth
    };
  }

  componentDidMount() {
    this.$el = $(this.el);
    this.state.onTableElementSet(this.el);

    // Get visible column labels for data-label attributes in responsive mode
    const visibleColumnLabels = this.state.columns
      .filter(col => col.visible !== false)
      .map(col => col.label || "");

    // Wrap createdRow to inject data-labels when responsive
    const originalCreatedRow = this.state.createdRow;
    const responsiveCreatedRow = (row, data, dataIndex) => {
      if (this.state.responsive) {
        const cells = row.getElementsByTagName('td');
        for (let i = 0; i < cells.length && i < visibleColumnLabels.length; i++) {
          cells[i].setAttribute('data-label', visibleColumnLabels[i]);
        }
      }
      originalCreatedRow(row, data, dataIndex);
    };

    var dataTableOptions = {
      "dom": this.props.detailTable ? "<<'header-section' i <'spacer'>>t><'footer-section' pl>" : "<'table-card table-responsive' <'header-section' i <'spacer'>>t><'footer-section' pl>",
      "language": {
        "info": this.props.detailTable || !this.state.title ? "" : "<span class='dataTable-title'><strong><span class='dataTable-dark-text'>" + this.state.title + "</span> <span class='dataTable-title-total'>(_TOTAL_)</span></strong></span>",
        "infoEmpty": this.props.detailTable || !this.state.title ? "" : "<span class='dataTable-title'><strong><span class='dataTable-dark-text'>" + this.state.title + "</span> <span class='dataTable-title-total'>(_TOTAL_)</span></strong></span>",
        "zeroRecords": this.state.zeroRecords,
        "infoFiltered": "",
        "lengthMenu": "Show: _MENU_",
        "search": "",
        "searchPlaceholder": "",
        "paginate": {
          "previous": "&larr;",
          "next": "&rarr;"
        }
      },
      "lengthMenu": this.state.lengthMenu,
      "autoWidth": this.state.autoWidth,
      "processing": true,
      "serverSide": true,
      "rowCallback": this.state.rowCallback,
      "drawCallback": this.state.drawCallback,
      "ajax": {
        "url": this.state.dataSource,
        "data": (d) => {
          return Object.assign({}, d, this.state.reducedFilters);
        },
        "dataSrc": (response) => {
          if(response.data.length){
            this.$el.removeClass("data-table-empty");
          } else {
            this.$el.addClass("data-table-empty");
          }

          return response.data;
        }
      },
      "order": this.state.order,
      "pagingType": "simple_numbers",
      "columns": this.state.columns,
      "initComplete": this.state.onInitComplete,
      "createdRow": responsiveCreatedRow
    };

    if(this.state.searchedSearchTerm.length > 0){
      dataTableOptions = Object.assign({}, dataTableOptions, {
        "oSearch": {"sSearch": this.state.searchedSearchTerm}
      });
    }

    this.dataTable = this.$el.dataTable(dataTableOptions);

    var dataTableForClick = this.$el.DataTable();
    var onRowClickFunc = this.state.onRowClick;
    this.$el.on('click', 'tbody > tr', function(e){
      var data = dataTableForClick.row(this).data();
      onRowClickFunc(e, data, this);
    });

    this.$el.DataTable().on('order.dt', (e, settings, details) => {
      this.state.onColumnReorder(e, settings, details);
    });
  }

  componentWillUnmount() {
    this.$el.DataTable().destroy();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.searchedSearchTerm !== this.props.searchedSearchTerm) {
      this.$el.DataTable().search(this.props.searchedSearchTerm).draw();
    }

    if (!isEqual(prevProps.reducedFilters, this.props.reducedFilters)) {
      this.setState({reducedFilters: this.props.reducedFilters});

      setTimeout(() => {
        this.$el.DataTable().ajax.reload();
      }, 1)
    }
  }

  render() {
    const wrapperClasses = this.state.responsive
      ? "table-responsive responsive-card-table-wrapper"
      : "table-responsive";
    const tableClasses = this.state.responsive
      ? "table responsive-card-table " + this.state.tableClassNames
      : "table " + this.state.tableClassNames;

    return (
      <div className={wrapperClasses}>
        <table className={tableClasses} style={{width: "100%"}} ref={el => this.el = el} data-source={this.state.dataSource}>
          {this.state.colGroup ? this.state.colGroup : null}
          <thead>
            <tr>
              {this.state.columns.map((column, i) =>
                <th key={i}>{column.label}</th>
              )}
            </tr>
          </thead>
          <tbody>
          </tbody>
        </table>
      </div>
    );
  }
}

export default DataTable;
